import { useState, useCallback, useRef } from 'react';
import { clientesApi } from '@/services/clientesApi';
import api from '@/services/api';
import type { ClienteDto } from '@/types/cliente';

export function useDniLookup() {
  const [cliente, setCliente] = useState<ClienteDto | null>(null);
  const [nombreFactiliza, setNombreFactiliza] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const searchByDni = useCallback((dni: string) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    const isDni = dni.length === 8;
    const isRuc = dni.length === 11;
    if (!isDni && !isRuc) {
      setCliente(null);
      setNombreFactiliza(null);
      return;
    }

    setLoading(true);
    timeoutRef.current = setTimeout(async () => {
      try {
        // 1. Factiliza: obtener nombre
        try {
          const res = await api.get<{ nombre: string }>(`/dni/${dni}`);
          setNombreFactiliza(res.data.nombre || null);
        } catch {
          setNombreFactiliza(null);
        }

        // 2. DB local: obtener otros datos del cliente (rubro, correo, etc.)
        try {
          const result = await clientesApi.findByDni(dni);
          setCliente(result);
        } catch {
          setCliente(null);
        }
      } finally {
        setLoading(false);
      }
    }, 400);
  }, []);

  const clearCliente = useCallback(() => {
    setCliente(null);
    setNombreFactiliza(null);
  }, []);

  return { cliente, nombreFactiliza, loading, searchByDni, clearCliente };
}
